<template>
  <div class="e1-billing">
    <h1 class="e1-billing__header">Billing Info</h1>
    <div class="e1-billing__description">
      <span v-html="customBillingInstruction"/>
      <span v-html="customBillingDescription"/>
    </div>
    <e1-adyen-dropin
      :acquisition-flow="true"
      :show-text="false"
      button_text="Agree & Subscribe"
      @success="onSuccess"
    />
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import E1AdyenDropin from './E1AdyenDropin';
import SubscriptionMixin from '@/shared/subscriptionMixin';

export default {
  name: 'E1Billing',
  components: {
    E1AdyenDropin,
  },
  mixins: [SubscriptionMixin],
  data() {
    return {};
  },
  computed: {
    ...mapGetters('signupflow', [
      'isStepAvailable',
    ]),
    ...mapGetters([
      'selectedPlan',
    ]),
    isAvailable() {
      return this.isStepAvailable('billing');
    },
    successRoute() {
      return { ...this.$route.meta.next };
    },
    customBillingInstruction() {
      return this.selectedPlan && this.selectedPlan.isHolidayPromo
        ? 'Enter your billing information to complete your account set-up and start your 7-day free trial.'
        : this.billingInstruction;
    },
    customBillingDescription() {
      return '';
      /*
      return this.selectedPlan && this.selectedPlan.isHolidayPromo
        ? ''
        : this.billingDescription;
       */
    },
  },
  watch: {
    isAvailable(v) {
      this.processAvailability(v);
    },
  },
  mounted() {
    if (this.$route.query.newSubscription) {
      // came from PaymentSecondStep after payment redirect
      this.$router.push(this.successRoute);
      return;
    }
    this.processAvailability(this.isAvailable);
    this.setMetaInformation('Sign Up | Luminary', 'Get your Luminary subscription today & listen to original podcasts you won\'t find anywhere else. Start your 7-day free trial now!');
  },
  destroyed() {
    this.setMetaInformation();
  },
  methods: {
    ...mapActions('signupflow', [
      'setCompleted',
    ]),
    processAvailability(isAvailable) {
      if (!isAvailable) {
        this.$router.replace(this.$route.meta.prev);
      }
    },
    onSuccess() {
      const { selectedPlan } = this.$store.getters;
      if (selectedPlan != null) {
        this.trackSteps({ step: 'stepThree', flowType: 'exp' });
      }
      this.$router.push(this.successRoute);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.e1-billing {
  display: flex;
  align-items: center;
  flex: 1 1 auto;
  justify-content: start;
  flex-flow: column;
  &__header {
    font-family: $serif-bold;
    font-size: 36px;
  }
  &__description {
    font-size: 16px;
    max-width: 500px;
    text-align: center;
    margin-bottom: 30px;
  }
}
</style>
